var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairwayConnection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 71,
    viewBox: "0 0 80 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_2341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09062 0.390488C6.86562 0.897644 5.89062 1.87333 5.38437 3.09993C5.13281 3.70689 5 4.34827 5 5.0053L5 25.0289C5 27.7962 7.23594 30.0348 10 30.0348C12.7641 30.0348 15 27.7962 15 25.0289L15 17.0899L66.4687 68.6155C68.4219 70.5709 71.5859 70.5709 73.5391 68.6155C75.4906 66.6616 75.4938 63.4938 73.5391 61.5368L22.0781 10.0112L30 10.0112C32.7641 10.0112 35 7.77263 35 5.0053C35 2.23797 32.7641 -0.000603936 30 -0.000603815L10 -0.000602941C9.35 -0.000602912 8.70156 0.12455 8.09062 0.390488ZM36.4687 45.6626L29.3984 38.584L6.46562 61.536C4.5125 63.4914 4.5125 66.6592 6.46563 68.6147C8.41719 70.5685 11.5812 70.5717 13.5359 68.6147L36.4687 45.6626ZM45 5.0053C45 7.77263 47.2359 10.0112 50 10.0112L57.9297 10.0112L43.5344 24.4235L50.6047 31.5022L65 17.082L65 25.0289C65 27.7962 67.2359 30.0348 70 30.0348C72.7641 30.0348 75 27.7962 75 25.0289L75 5.0053C75 4.3539 74.8675 3.70501 74.6155 3.09367C74.1089 1.86722 73.1342 0.891072 71.9092 0.384221C71.2969 0.124539 70.6562 -0.000605592 70 -0.000605563L50 -0.000604689C47.2344 -0.000604568 45 2.23641 45 5.0053Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_2341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.0826,
    height: 80,
    fill: "white",
    transform: "translate(0 70.082) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairwayConnection);
export default __webpack_public_path__ + "static/media/fairway-connection.bfb0a0a40595a541523fa78ee5f88a78.svg";
export { ForwardRef as ReactComponent };